import { z } from 'zod';

import { schemaId } from '../utils/schema.utils';

export const schemaChatInboundReadReceiptSharedPayload = z.object({
    attempt: z.number().int().nonnegative(),
    inboundSequence: z.number().int().nonnegative(),
    lastSeenMessageId: schemaId,
    metaMessageId: z.string().min(1),
    phoneNumberId: z.string().min(1),
});
